import axios, { AxiosError, AxiosResponse } from "axios";
import qs from "qs";

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_HOST,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "comma" }),
  withCredentials: true,
  timeout: 60 * 1000,
});

export const GET = async <T>(
  endpoint: string,
  params?: Record<string, any>,
  signal?: AbortSignal
): Promise<T> => {
  return apiClient
    .get(endpoint, { params, signal })
    .then((response) => response.data) // 여기서는 data만 반환
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const POST = async (
  endpoint: string,
  data: Record<string, any>
): Promise<AxiosResponse> => {
  return apiClient
    .post(endpoint, data, { withCredentials: true })
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const PUT = async (
  endpoint: string,
  data: Record<string, any>
): Promise<AxiosResponse> => {
  return apiClient
    .put(endpoint, data)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};

export const DELETE = async (endpoint: string): Promise<AxiosResponse> => {
  return apiClient
    .delete(endpoint)
    .then((response) => response.data)
    .catch((error: AxiosError) => {
      throw error;
    });
};
